import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;
  text-align: center;
  padding: 0 20px;
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 25px;
`;

const Title = styled.div`
  font-size: 64px;
  font-weight: 700;
  color: #343a40;
  
  @media (max-width: 768px) {
    font-size: 48px;
  }
`;

const SubTitle = styled.div`
  font-size: 28px;
  font-weight: 400;
  color: #6c757d;
  
  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const Tagline = styled.div`
  font-size: 20px;
  font-weight: 300;
  color: #6c757d;
  margin-top: 10px;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const TitleSection = () => {
  return (
    <Container>
      <Contents>
        <Title>Following Moments</Title>
        <SubTitle>장소를 따라, 순간을 기록하다</SubTitle>
        <Tagline>Your journey, beautifully captured.</Tagline>
      </Contents>
    </Container>
  );
};

export default TitleSection;
